import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/resultCardRacing.css';
import {getFormattedCurrency, getText, usingNonDecimalCurrency} from '../../../helpers/localization';
import {TRICAST} from '../modules/racing/constants/identifiers';
import {CITY_DOGS, DOGS, HARD_SUSPENDED, MAD, MARBLES, MOTOR_RACING, RSD} from "../../../constants/identifiers";
import {ASSETS_URL} from '../../../constants/endpoints';
// helpers
import {hasEventTypeRacerNumberUI, isMarbleEuroEvent} from '../modules/racing/helpers/racersHelper';
import {roundNumber, roundNumberForCurrency} from "../../../helpers/mathFunctions";
import {calculateEachWayValuesFirstOrPlaced} from "../../../helpers/eachWayBetHelpers";
//actions
import {getGameFromChannel} from "../helpers/gameHelpers";
import {getAllWrappedBets} from '../helpers/betHelpers';
import {BASE_VALUE} from '../../../constants/chips';
import {getPotentialReturn} from '../modules/matchday/helpers/matchdayHelper';

const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        games: state.vpp.games,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedGameIndex: state.vpp.selectedGameIndex,
        systemLanguage: state.vpp.systemLanguage,
        channelEventBets: state.vpp.channelEventBets
    };
};

class ResultCardRacing extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            games: storeData.vpp.games,
            events: storeData.vpp.events,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            systemLanguage: storeData.vpp.systemLanguage,
            channelEventBets: storeData.vpp.channelEventBets
        };
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                games: storeData.vpp.games,
                events: storeData.vpp.events,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                systemLanguage: storeData.vpp.systemLanguage,
                channelEventBets: storeData.vpp.channelEventBets,
            });
        }
    }

    _getRacerUI(racer, positionNumber, word, hasWon, eventType) {

        let store = this.props.store;
        let storeData = store.getState();
        let racerIcon;
        let racerIconImage;
        let singleBetGameCardContainer = style.singleBetGameCardContainer;
        let backgroundColor = '';
        let positionCont = style.positionContainer;
        let gameName = this.state.games[this.state.selectedGameIndex].name;
        let isEuroEvent = isMarbleEuroEvent(eventType, gameName);

        switch (eventType) {
            case MOTOR_RACING:
                if (this.state.games[this.state.selectedGameIndex].assetsPath === 'motorRacing') {
                    racerIcon = style.motorSpeedwayParkIcon;
                    racerIconImage = style.motorSpeedwayParkImage;
                    positionCont = style.positionContainerNoNumber;
                    singleBetGameCardContainer = style.singleBetGameCardContainerNoNumber;
                } else {
                    racerIcon = style.motorAutoRacewayIcon;
                    racerIconImage = style.motorAutoRacewayImage;
                    positionCont = style.positionContainerNoNumber;
                    singleBetGameCardContainer = style.singleBetGameCardContainerNoNumber;
                }
                break;
            case MARBLES:
                if (isEuroEvent) {
                    racerIconImage = style.euroMarbleRacerIconImage
                    backgroundColor = style.backGroundEuroMarble
                    racerIcon = style.euroMarbleRacerIcon;
                    positionCont = style.euroMarblePositionContainer;
                } else {
                    racerIconImage = style.marbleRacerIconImage
                    backgroundColor = style.backGroundColor
                    racerIcon = style.marbleRacerIcon;
                }
                break;
            case DOGS:
            case CITY_DOGS:
                racerIcon = style.dogRacerIcon;
                racerIconImage = style.dogRacerIconImage;
                positionCont = style.positionContainerNoNumber;
                singleBetGameCardContainer = style.singleBetGameCardContainerNoNumber;
                break;
            default:
                racerIcon = style.racerIcon;
                racerIconImage = style.racerIconImage;
                backgroundColor = style.backGroundColor;
                break;
        }
        let flagImage;
        let goldBackGroundStyle = (positionNumber === 1 && hasWon) ? style.win : '';
        let racerImage = `${ASSETS_URL}${getGameFromChannel(this.state.events[this.state.selectedEventIndex].channel, storeData.vpp.games).assetsPath}/silks/silk${Number(racer)}.png`;

        if (isEuroEvent) {
            racerImage = `${ASSETS_URL}${getGameFromChannel(this.state.events[this.state.selectedEventIndex].channel, storeData.vpp.games).assetsPath}/silks/marbles/silk${Number(racer)}.png`;
            flagImage = `${ASSETS_URL}${getGameFromChannel(this.state.events[this.state.selectedEventIndex].channel, storeData.vpp.games).assetsPath}/silks/flags/silk${Number(racer)}.png`;
        }

        return (
            <div id={'racer_' + racer} className={`${singleBetGameCardContainer} ${backgroundColor}`}>
                <div id={'racer_silk_' + racer} className={`${racerIcon}`}>
                    <img
                        src={racerImage}
                        className={`${racerIconImage}`}
                        alt={`icon${racer}`}/></div>

                {flagImage ?
                    (<div id={'racer_silk_flag' + racer} className={style.euroMarbleRacerFlagIcon}>
                        <img
                            src={flagImage}
                            className={`${style.racerFlagIconImage}`}
                            alt={`icon${racer}`}/></div>) : ""
                }
                {
                    !(isEuroEvent) ?
                        hasEventTypeRacerNumberUI(eventType)
                            ? (<div id={'slider_racer_number_' + racer} className={style.silkNumber}>{racer}</div>)
                            : '' : ''
                }
                <div className={`${positionCont} ${goldBackGroundStyle}`}>
                    <div className={`${isEuroEvent ? style.euroMarblePositionBox : ""} ${style.positionBox}`}>
                        <div className={style.centerPositionBox}>
                            <div className={`${style.positionNumber}`}>
                                {positionNumber}
                            </div>
                            <div className={style.position}>
                                {word}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    _getRacersList(winners, hasWon) {
        let positionWord = ['ST', 'ND', 'RD'];
        let position = ['FIRST_ST', 'SECOND_ND', 'THIRD_RD'];
        let eventType = this.state.events[this.state.selectedEventIndex].eventType;
        let listOfSingleBetsCardsUI = winners.map((winner, index) => {

            return this._getRacerUI(winner, getText(position[index], this.props.store), getText(positionWord[index], this.props.store), hasWon, eventType);

        });

        return listOfSingleBetsCardsUI;
    }

    render() {
        let game = this.state.games.find((game) => game.channel === this.state.games[this.state.selectedGameIndex].channel && game.lastResult !== undefined);
        if (game !== undefined) {
            let placedBets = getAllWrappedBets(this.state, game.channel);
            let eventActiveBets = [];
            let winners = [];
            let totalReturns = 0;
            let lookForNextText = '';
            let scheduledEventText = '';
            let returnsText = '';
            let prizeAmount = '';
            let eventResult = game.lastResult.result.split(',');
            let containerStyle = style.rightContainer;
            let systemCurrency = this.props.store.getState().vpp.systemCurrency;

            for (let k = 0; k < eventResult.length - 1; k++) {
                if (eventResult[k].startsWith(TRICAST.code)) {
                    winners = eventResult[k].split('_')[1].split('-');
                }
            }

            if (placedBets && placedBets.length) {
                let completeBets = [];
                // only add the active bets to the array if game isn't hard suspended.
                // Hard suspension do not pay the bet when settled
                if (game.state !== HARD_SUSPENDED) {
                    completeBets = placedBets.slice();
                }

                eventActiveBets = completeBets.filter((aBet) => {
                    let exists = aBet.Bets.find((bet) => {
                        let eventBetExists = bet.EventId === game.lastResult.eventId && bet.Channel === game.lastResult.channel;
                        return eventBetExists;
                    });
                    return exists !== undefined;
                });

                if (eventActiveBets && eventActiveBets.length) {
                    for (let j = 0; j < eventActiveBets.length; j++) {
                        for (let i = 0; i < eventResult.length - 1; i++) {

                            let bet = eventActiveBets[j].Bets[0];
                            if (eventResult[i] === bet.Market.Id || bet.ExternalRefId !== undefined) {
                                let currentPotentialReturn = 0;
                                if (bet.ExternalRefId !== undefined) {
                                    let stake = 0;

                                    if (usingNonDecimalCurrency(systemCurrency)) {
                                        stake = roundNumber((bet.Stake / 2), 2);
                                    } else {
                                        stake = roundNumber((bet.Stake / 2) / BASE_VALUE, 2);
                                    }
                                    let firstPlace = eventResult.includes("1_" + bet.Market.Num);
                                    if (firstPlace ||
                                        eventResult.includes("2_" + bet.Market.Num) ||
                                        ((this.state.events[this.state.selectedEventIndex].eventType !== DOGS || this.state.events[this.state.selectedEventIndex].eventType !== CITY_DOGS) && eventResult.includes("3_" + bet.Market.Num))) {
                                        let marketInfo = bet.OpaqueData === undefined ? null : JSON.parse(bet.OpaqueData);
                                        let ewValues = calculateEachWayValuesFirstOrPlaced(stake, bet.Market.Price, marketInfo.eachWayRatio, firstPlace);
                                        currentPotentialReturn = ewValues.potentialReturns;
                                        //promobet logic 
                                        if(!(bet.PromoId === 'real_bet')){
                                            currentPotentialReturn = currentPotentialReturn - stake;
                                        }
                                        totalReturns = totalReturns + roundNumberForCurrency(currentPotentialReturn, systemCurrency);
                                        break;
                                    }
                                } else {
                                    let stake = 0;
                                    if (usingNonDecimalCurrency(systemCurrency)) {
                                        stake = roundNumber(bet.Stake, 2);
                                    } else {
                                        stake = roundNumber(bet.Stake / BASE_VALUE, 2);
                                    }
                                    if (Number(stake) && Number(bet.Market.Price)) {
                                        currentPotentialReturn = roundNumberForCurrency(getPotentialReturn(bet.Market.Price, stake, 1, 0), systemCurrency);
                                        //promobet logic 
                                        if(!(bet.PromoId === 'real_bet')){
                                            currentPotentialReturn = currentPotentialReturn - stake;
                                        }
                                        totalReturns = totalReturns + roundNumberForCurrency(currentPotentialReturn, systemCurrency);
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (totalReturns !== 0) {
                returnsText = (<div
                    className={systemCurrency === RSD || systemCurrency === MAD ? style.winTextNonSymbolCurrency : style.winText}>{getText('RETURNS', this.props.store)}</div>);
                prizeAmount = (<div
                    className={systemCurrency === RSD || systemCurrency === MAD ? style.winTextNonSymbolCurrency : style.winText}>{getFormattedCurrency(this.props.store, totalReturns, 2)}</div>);

            } else {
                lookForNextText = (
                    <div className={style.lookForNextOnly}>{getText('LOOK_FOR_THE_NEXT', this.props.store)}</div>);
                scheduledEventText = (
                    <div className={style.lookForNextOnly}>{getText('SCHEDULED_EVENT', this.props.store)}</div>);
                containerStyle = style.rightContainerForNextOnly;
            }

            let racersUI = [];
            let racersList = this._getRacersList(winners, totalReturns !== 0);

            let auxUI = (<div key={0} className={style.buttonsColumn}>
                <div className={style.buttonCol}>{(
                    <div key={0} className={style.buttonContainer}>{racersList[0]}</div>)}</div>
                <div className={style.buttonCol}>{(
                    <div key={1} className={style.buttonContainer}>{racersList[1]}</div>)}</div>
                <div className={style.buttonCol}>{(
                    <div key={2} className={style.buttonContainer}>{racersList[2]}</div>)}</div>
            </div>);
            racersUI.push(auxUI);

            return (
                <div className={style.mainContainer}>
                    <div className={style.leftContainer}>
                        {racersUI}
                    </div>
                    <div className={`${containerStyle}`}>
                        {lookForNextText}
                        {scheduledEventText}
                        {returnsText}
                        {prizeAmount}
                    </div>
                </div>

            );
        } else {
            return '';
        }
    }
}

export default connect(mapStateToProps)(ResultCardRacing);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/resultCardRacing.js